import { gql } from '@apollo/client';

export const QUERY_PROJECT_ANALYSIS_REPORTS_ADMIN = gql`
  query ProjectAnalysisReportsForAdmin {
    projectAnalysisReportsForAdmin {
      id
      title
      status
      published_at
      recipient_count
      created_at
      updated_at
    }
  }
`;

export const QUERY_PROJECT_ANALYSIS_REPORT_FOR_ADMIN = gql`
  query ProjectAnalysisReportForAdmin($report_id: String!) {
    projectAnalysisReportForAdmin(report_id: $report_id) {
      id
      title
      status
      published_at
      recipient_count
      created_at
      updated_at
      original_filename
      recipient_user_ids
    }
  }
`;

export const QUERY_MY_PROJECT_ANALYSIS_REPORTS = gql`
  query MyProjectAnalysisReports {
    myProjectAnalysisReports {
      id
      title
      published_at
      original_filename
    }
  }
`;
